export default {
  props: {
    checkItem: {
      required: true,
      type: Object
    },
    measureInstruments: {
      required: true,
      type: Array
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Data/TaskResult/BaseTaskResultOptionComponent.js